"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _typography = require("../../theme/base/typography");
const baseStyle = {
  lineHeight: 1.5,
  fontWeight: _typography.fontWeights.normal
};
const variants = exports.variants = {
  body: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.base,
      desktop: _typography.fontSizes.base
    }
  },
  body2: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.sm,
      desktop: _typography.fontSizes.sm
    }
  },
  caption: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.xs,
      desktop: _typography.fontSizes.xs
    }
  }
};
const defaultProps = {
  variant: variants.body
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Text, {
  variants,
  baseStyle,
  defaultProps
});